// Plan-based feature permissions
// Single source of truth for plan IDs and feature access

export const PLAN_IDS = {
  BUSINESS: 'business',
  BUSINESS_PLUS: 'businessPlus',
  PREMIUM: 'premium',
};

const PLAN_FEATURES = {
  [PLAN_IDS.BUSINESS]: {
    bulkCheques: false,
    recurringPdc: false,
    zohoIntegration: false,
    documentAttachments: false,
    maxUsers: 2,
  },
  [PLAN_IDS.BUSINESS_PLUS]: {
    bulkCheques: true,
    recurringPdc: true,
    zohoIntegration: true,
    documentAttachments: false,
    maxUsers: 5,
  },
  [PLAN_IDS.PREMIUM]: {
    bulkCheques: true,
    recurringPdc: true,
    zohoIntegration: true,
    documentAttachments: true,
    maxUsers: 10,
  },
};

export const canAccess = (planId, feature) => {
  const features = PLAN_FEATURES[planId];
  if (!features) return false;
  return !!features[feature];
};

export const getMaxUsers = (planId) => {
  return PLAN_FEATURES[planId]?.maxUsers ?? 2;
};

export const getPlanName = (planId) => {
  const names = {
    [PLAN_IDS.BUSINESS]: 'Business',
    [PLAN_IDS.BUSINESS_PLUS]: 'Business Plus',
    [PLAN_IDS.PREMIUM]: 'Premium',
  };
  return names[planId] || 'Business';
};
